var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"c-form__fieldset c-fieldset",class:{
        'c-fieldset--disabled': _vm.Disabled
    }},[_vm._t("Title",[_c('legend',{staticClass:"c-form__fieldset-legend"},[_vm._v(_vm._s(_vm.Title))])]),_vm._t("default"),(_vm.Disabled)?_c('div',{staticClass:"c-fieldset__lock-overlay"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }